import React, {Component} from "react";

/**
 * Values accessible by the UiContext's children. These need to be passed into the value property in the Provider in order to be accessible.
 * @param {boolean} isExpanded - True when footer is expanded. The positions of related UI elements will need to adapted to its new dimension. 
 * Thus, we keep track of it in a parent context. 
 * @param {function} onExpandFooter - The callback that triggers when the menu button is pressed. */
export interface UiContextProps {
    isExpanded: boolean
    onExpandFooter: () => void
}

/**
 * The Context for UI state management. This context allows child components to easily access/modify data that nested components need 
 * (via useContext) without having to explicitly recieve it as a property from a parent component. Should be used sparingly, as it makes 
 * components that depend on it less reusable. */
export const UiContext = React.createContext<UiContextProps | null>(null);

/**The UiProvider allows all its child components to access its state data via useContext().*/
export class UiProvider extends Component<{children: React.ReactNode}, {isExpanded: boolean}> {
    constructor(props: any) {
        super(props);
        this.state = {
            isExpanded: false
        };
    }
 
    render() {
        const { isExpanded } = this.state;
        const { children } = this.props;
        const data = {
            isExpanded: isExpanded,
            onExpandFooter: () => this.setState(prevState => ({isExpanded: !prevState.isExpanded}))
        };

        return (
            <UiContext.Provider value={data}>
                {children} 
            </UiContext.Provider>
        );
    }
}